import React, {Component} from 'react';
import { EditorBlock } from 'draft-js';
import PropTypes from 'prop-types';

class EditorHTML extends Component {
  render() {
    const { block } = this.props;
    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: block.getText() }} />
        <pre>
          <EditorBlock {...this.props} />
        </pre>
      </div>
    );
  }
}

EditorHTML.propTypes = {
  block: PropTypes.object,
};
EditorHTML.defaultProps = {};

export default EditorHTML;



// WEBPACK FOOTER //
// ./src/cms/form/editor/EditorHTML.js